<template>
    <div class="base-real-name-modify" :class="{'real-md': $store.state.screen == 1}">
        <div class="content">
            <div class="header">
                <div class="back-img" @click="$router.back()">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">修改认证</div>
                <div class="service-img" @click="$router.push('/base-service')">
                    <img class="ser" src="~images/user_service.png" />
                </div>
            </div>
            <div class="content-auto">
                <div class="tips">
                    根据国家相关规定，游戏用户需进行实名认证，未实名或未成年用户将限制每日游戏时间、充值消费等，具体详情请查看
                    <span @click="$router.push('/base-indulge')">《防沉迷政策》</span>
                </div>
                <input class="val" type="text" placeholder="请输入真实姓名" v-model="real_name" />
                <input class="val" type="text" placeholder="请输入身份证号码" v-model="id_card" />
                <transition name="component-fade" mode="out-in">
                    <TheTips :msg='msg' v-if="msg" />
                </transition>
            </div>
        </div>
        <div class="btn" @click="submit">确认修改</div>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        name: 'BaseRealNameModify',
        components:{
            TheTips
        },
        data () {
            return {
                msg: null,
                accountData: {},
                real_name: '',
                id_card: ''
            }
        },
        methods: {
            // 修改实名验证（与提交实名验证一致）
            submit () {
                // 身份证号码正则表达式  15位或者18位，15位为全数字，18位前17位为数字，最后一位可能是数字或字符X
                let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
                if (!this.real_name.replace(/\s*/g, "")) {
                    this.msg = '真实姓名不能为空'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                if(!reg.test(this.id_card)) {
                    this.msg = '身份证号码不合法'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                let h5LoginData = JSON.parse(sessionStorage.getItem('h5LoginData'))    //+
                let options = {
                    uid: this.accountData.uid,
                    real_name: this.real_name,
                    id_card: this.id_card,
                    appid: h5LoginData.appid,
                }
                options.sign = this.util.getSign(options, h5LoginData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=id_auth', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        // 更新用户信息
                        this.userCenterSdk()
                        this.msg = '提交成功'
                        setTimeout(() => {
                            this.msg = null
                            this.$router.back()
                        }, 1000)
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            },
            // 获取用户信息
            userCenterSdk () {
                let options = {
                    uid: this.accountData.uid,
                };
                options.sign = this.util.getSign(options)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=userbox&a=user_center_sdk', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.$store.commit('setUserName', res.data.data.username)
                        sessionStorage.setItem('setUserData', JSON.stringify(res.data.data))
                    }
                })
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            let userData = JSON.parse(sessionStorage.getItem('setUserData'))
            this.real_name = userData.real_name
            this.id_card = userData.id_card
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-real-name-modify {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        padding-bottom: 60px;
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .content {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow-y: scroll;
            .header {
                height: 132px;
                background: rgba($color, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                .back-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .back {
                        width: 72px;
                        height: 72px;
                    }
                }
                .title {
                    font-size: 51px;
                    text-align: center;
                }
                .service-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .ser {
                        width: 72px;
                        height: 72px;
                    }
                }
            }
            .content-auto {
                flex: 1;
                overflow-y: scroll;
                padding: 0 60px;
                .tips {
                    font-size: 39px;
                    margin: 80px 0 60px;
                }
                .tips span {
                    color: $color;
                }
                .val {
                    width: 100%;
                    height: 120px;
                    color: #fff;
                    font-size: 39px;
                    border-radius: 18px;
                    border: 0;
                    background: rgba(255, 255, 255, 0.2);
                    padding: 0 45px;
                    margin-bottom: 60px;
                    outline: none;
                }
                input::-webkit-input-placeholder{
                    color:rgba(255, 255, 255, 0.5);
                }
                input::-moz-input-placeholder{
                    color:rgba(255, 255, 255, 0.5);
                }
                input::-ms-input-placeholder{
                    color:rgba(255, 255, 255, 0.5);
                }
                input::-o-input-placeholder{
                    color:rgba(255, 255, 255, 0.5);
                }
            }
        }
        .btn {
            height: 120px;
            font-size: 39px;
            border-radius: 18px;
            background: $color;
            margin: 0 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    // 竖屏css
    .real-md {
        width: 100%;
        height: 100%;
        padding-bottom: 90px;
        .content {
            .header {
                height: 240px;
                border-radius: 60px 0 0 0;
                .back-img {
                    width: 290px;
                    height: 240px;
                    .back {
                        width: 130px;
                        height: 130px;
                    }
                }
                .title {
                    font-size: 92px;
                }
                .service-img {
                    width: 290px;
                    height: 240px;
                    .ser {
                        width: 130px;
                        height: 130px;
                    }
                }
            }
            .content-auto {
                padding: 0 90px;
                .tips {
                    font-size: 70px;
                    margin: 145px 0 90px;
                }
                .val {
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                    padding: 0 81px;
                    margin-bottom: 90px;
                }
            }
        }
        .btn {
            height: 200px;
            font-size: 70px;
            border-radius: 32px;
            margin: 0 90px;
        }
    }
</style>